export default () => {
  return {
    restrict: 'A',
    scope: {
      infiniteLoadingCallback: '&infiniteLoading'
    },
    link: (scope, element) => {
      let rawElement = element[0];

      element.bind('scroll', () => {
        if (rawElement.scrollTop + rawElement.offsetHeight >= (rawElement.scrollHeight - 50)) {
          scope.$apply(scope.infiniteLoadingCallback);
        }
      });
    }
  };
};